window.addEventListener('load', event => {
    // FAQ Panel accordions
    let faqPanels = document.querySelectorAll('.faq-panel');
    for (let faqPanel of faqPanels) {
        let accordions = faqPanel.querySelectorAll('.accordion');
        let extraCards = faqPanel.querySelectorAll('.faq-extra-card');
        let showMoreButton = faqPanel.querySelectorAll('.faq-load-more-button');

        for (let button of showMoreButton) {
            let buttonShowMoreText = button.dataset.showmoretext;
            let buttonShowLessText = button.dataset.showlesstext;

            button.addEventListener('click', event => {
                const minusIcon = '<svg class="w-auto h-4 max-w-[1.25rem] fill-current pointer-events-none" width="22" height="18" viewBox="0 0 22 18" fill="#0D361D" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M3 9C3 8.44772 3.44772 8 4 8H18C18.5523 8 19 8.44772 19 9C19 9.55228 18.5523 10 18 10H4C3.44772 10 3 9.55228 3 9Z" fill="inherit"/>\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 9C2.5 8.17157 3.17157 7.5 4 7.5H18C18.8284 7.5 19.5 8.17157 19.5 9C19.5 9.82843 18.8284 10.5 18 10.5H4C3.17157 10.5 2.5 9.82843 2.5 9ZM4 8.5C3.72386 8.5 3.5 8.72386 3.5 9C3.5 9.27614 3.72386 9.5 4 9.5H18C18.2761 9.5 18.5 9.27614 18.5 9C18.5 8.72386 18.2761 8.5 18 8.5H4Z" fill="inherit"/>\n' +
                    '</svg>';

                const plusIcon = '<svg class="w-auto h-4 max-w-[1.25rem] fill-current pointer-events-none" width="22" height="18" viewBox="0 0 22 18" fill="#0D361D" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M11 1C11.5523 1 12 1.44772 12 2V16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16V2C10 1.44772 10.4477 1 11 1Z" fill="inherit"/>\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 2C9.5 1.17157 10.1716 0.5 11 0.5C11.8284 0.5 12.5 1.17157 12.5 2V16C12.5 16.8284 11.8284 17.5 11 17.5C10.1716 17.5 9.5 16.8284 9.5 16V2ZM11 1.5C10.7239 1.5 10.5 1.72386 10.5 2V16C10.5 16.2761 10.7239 16.5 11 16.5C11.2761 16.5 11.5 16.2761 11.5 16V2C11.5 1.72386 11.2761 1.5 11 1.5Z" fill="inherit"/>\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M3 9C3 8.44772 3.44772 8 4 8H18C18.5523 8 19 8.44772 19 9C19 9.55228 18.5523 10 18 10H4C3.44772 10 3 9.55228 3 9Z" fill="inherit"/>\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 9C2.5 8.17157 3.17157 7.5 4 7.5H18C18.8284 7.5 19.5 8.17157 19.5 9C19.5 9.82843 18.8284 10.5 18 10.5H4C3.17157 10.5 2.5 9.82843 2.5 9ZM4 8.5C3.72386 8.5 3.5 8.72386 3.5 9C3.5 9.27614 3.72386 9.5 4 9.5H18C18.2761 9.5 18.5 9.27614 18.5 9C18.5 8.72386 18.2761 8.5 18 8.5H4Z" fill="inherit"/>\n' +
                    '</svg>\n'

                if (button.innerText === buttonShowMoreText) {
                    for (let card of extraCards) {
                        button.innerHTML = buttonShowLessText + minusIcon;
                        card.classList.remove('faq-extra-card', '!h-0', '!-mt-4', 'overflow-hidden', 'pointer-events-none', 'select-none', '!opacity-0');
                    }
                } else {
                    for (let card of extraCards) {
                        button.innerHTML = buttonShowMoreText + plusIcon;
                        card.classList.add('faq-extra-card', '!h-0', '!-mt-4', 'overflow-hidden', 'pointer-events-none', 'select-none', '!opacity-0');
                    }
                }
            })
        }

        for (let accordion of accordions) {
            let accordionToggle = accordion.querySelector('.accordion-visible');
            let accordionHidden = accordion.querySelector('.accordion-hidden');
            let accordionIcon = accordion.querySelector('.accordion-icon-p1');
            let accordionQuestionText = accordion.querySelector('.accordion-question-text')
            let accordionShowMoreLessText = accordion.querySelector('.accordion-show-more-less-text');
            let accordionHiddenHeight = 0;
            let locked = false;
            let resetAccordionDebounce =  _debounce(resetAccordion, 50, {leading: true, trailing: true});
            let accordionWidth = accordion.offsetWidth;

            accordionToggle.addEventListener('click', event => {
                accordionWidth = accordion.offsetWidth;
                if (event.target === accordionHidden || accordionHidden.contains(event.target)) {
                    return;
                }
                let open = accordionShowMoreLessText.innerHTML === accordionShowMoreLessText.dataset.showlesstext;

                if (open && !locked) {
                    // resets accordion to closed state / removes related event listener
                    accordionShowMoreLessText.innerHTML = accordionShowMoreLessText.dataset.showmoretext;
                    accordionIcon.classList.remove('!h-[.125rem]');
                    accordionHidden.classList.add('!h-0');
                    accordionQuestionText.classList.remove('text-green-pale');
                    window.removeEventListener('resize', resetAccordionDebounce);
                } else {
                    // sets accordion to open state / locks to prevent multiple event listeners being added.
                    locked = true;
                    accordionShowMoreLessText.innerHTML = accordionShowMoreLessText.dataset.showlesstext;
                    accordionIcon.classList.add('!h-[.125rem]');
                    accordionQuestionText.classList.add('text-green-pale');

                    // calcs what accordion height would be when open
                    accordionHidden.classList.remove('transition-all');
                    accordionHidden.classList.remove('!h-0');
                    accordionHidden.removeAttribute('style');
                    accordionHiddenHeight = accordionHidden.offsetHeight;
                    accordionHidden.classList.add('!h-0');

                    // transitions to calculated height
                    // adds debounced event listener to close on resize as height is now set
                    setTimeout(() => {
                        accordionHidden.classList.add('transition-all');
                        accordionHidden.setAttribute('style',`height:${accordionHiddenHeight}px`);
                        window.addEventListener('resize', resetAccordionDebounce, {passive: true})
                        accordionHidden.classList.remove('!h-0');
                        locked = false;
                    }, 50);
                }
            });

            // On resize removes added event listener and resets open accordion to closed state
            // was going to adjust height initially hence debounce - just resetting for now
            function resetAccordion() {
                if (accordion.offsetWidth != accordionWidth) {
                    accordionShowMoreLessText.innerHTML = accordionShowMoreLessText.dataset.showmoretext;
                    accordionIcon.classList.remove('!h-[.125rem]');
                    accordionHidden.classList.add('!h-0');
                    accordionQuestionText.classList.remove('text-green-pale');
                    window.removeEventListener('resize', resetAccordionDebounce);
                }
            }
        }
    }
});